import { SearchItemType } from "@/components/Store/StoreSearchInput/storeSearchInput.types";

export const MAX_STORES_LIST = 10;
export const MAX_STORES_BY_LOCATION = 5;

export const ZOOM_INITIAL = 8.0;
export const ZOOM_BREAKPOINT = 10;
export const LOC_ZOOM = 11.5;
export const MARKER_OFFSET = -25;

export const STORE_SEARCH_LOCATOR_MESSAGE_ID = "storesearch-locator-error";

export const FIXED_STORE_FEATURES = ["openOnSunday"];

export const STORE_SEARCH_INPUT_TYPES = new Map<SearchItemType, number>([
    [SearchItemType.Store, 2],
    [SearchItemType.Locality, 3]
]);
